<template>
	<div class="message-box">
		<img
			class="error-image"
			src="@/assets/images/simulation-error.png"
			alt=""
		/>
		<h1 aria-live="assertive">{{ errorMessage }}</h1>
		<h2 v-if="showReachOutMessage">
			{{ $t('reachOutToTeacher') }}
		</h2>
		<div class="buttons-con">
			<div class="action-link-wrap">
				<button name="log-out" @click="logout()">
					{{ $t('logОut') }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import Accessibility from '@/mixins/Accessibility';
export default {
	mixins: [Accessibility],
	props: {
		errorMessage: {
			type: String,
			default: ''
		},
		userRoleName: {
			type: String,
			default: ''
		}
	},
	computed: {
		constants() {
			return this.$store.getters.constants;
		},
		showReachOutMessage() {
			if (
				this.userRoleName &&
				this.constants &&
				this.constants.adminUserRoleName
			) {
				return (
					this.userRoleName.toLowerCase() !=
					this.constants.adminUserRoleName.toLowerCase()
				);
			} else {
				return true;
			}
		}
	},
	mounted() {
		this.$store.commit('setLoading', false);
		setTimeout(() => {
			this.announceError(
				`${this.errorMessage} ${this.$t('reachOutToTeacher')}`
			);
		}, 200);
	},
	methods: {
		logout() {
			this.$store.dispatch('logout');
		}
	}
};
</script>

<style lang="scss" scoped>
body {
	background-color: #2f3242;
}

.message-box {
	padding-top: 5%;
	margin-left: auto;
	margin-right: auto;
	text-align: center;
	color: #fff;
	font-family: 'RobotoRegular';
	font-weight: 300;
	color: #687682;
	max-width: 40%;
	.error-image {
		margin-bottom: 32px;
		width: 80px;
		@media (min-width: $breakpoint-mid) {
			margin-bottom: 64px;
			width: initial;
		}
	}
}

.buttons-con .action-link-wrap {
	margin-top: 2.5em;
	@media (min-width: $breakpoint-mid) {
		margin-top: 3em;
	}
}

.buttons-con .action-link-wrap button {
	background: linear-gradient(123.25deg, #f82c5c 0%, #fcb98d 100%);
	padding: 8px 25px;
	border-radius: 4px;
	color: #fff;
	font-weight: bold;
	font-size: 14px;
	cursor: pointer;
	text-decoration: none;
	margin-right: 10px;
	border: 2px solid transparent;

	@media (min-width: $breakpoint-mid) {
		padding: 10px 28px;
		font-size: 16px;
	}
}

.buttons-con .action-link-wrap button:hover {
	border: 2px solid black;
}
</style>
